import React, { useContext } from 'react';

import s from './MenuButton.scss';
import { UIContext } from 'context/ui';

interface IProps {
  children?: React.ReactNode;
}

export const MenuButton = ({ children }: IProps) => {

  const { toggleNav, navOpen } = useContext(UIContext);
  
  return (
    <button
      onClick={() => toggleNav(!navOpen)}
      className={s('menuButton', { navOpen })}
      aria-controls="main-menu"
      aria-expanded={navOpen}
    >
      <span className={s.menuButton__inner}>
        <span className={s.menuButton__text}>{children ?? 'Menu'}</span>
      </span>
    </button>
    );
}
